<template>
  <v-sheet>
    <v-calendar
      v-model="calendarDate"
      ref="calendar"
      color="primary"
      type="month"
      :value="calendarValue"
      :locale="vuetifyLocale"
    >
      <template v-slot:day-label="{ date, day, month }">
        <div v-if="month === getCurrentMonth()">
          <div
            :class="['cell-day', { 'mobile': isMobile, }, {selected: isSelectedDate(date) }]"
            @click="handleClick(date)"
            style="height: 117px; width: 100%; margin-top: -5px"
          >
            <div style=" height: 30px; width: 100%;" @click="transitListApproved( date, 'blue') ">
              <div class="widthRate" :style="{ width: widthRate(date), float: 'left'}">
                <div
                  style="margin-top: -4px; margin-left: -8px"
                  :class="{
                    'current-day': isToday(day) && month === getCurrentMonth(),
                  }"
                  class="circle_blue1"
                >
                  <p>
                    <b>{{ day }}</b>
                  </p>
                </div>
              </div>
              <div class="day-container">
                <div v-if="hasStatus(date, '1')"
                  class="circle_blue circle-link" 
                  :class="{
                    selected: isSelectedDate(date) && selectedColor === 'blue',
                  }"
                  @click.stop="isMobile ? transitListApproved(date, 'blue') : approvedVacation(date, 'blue')"
                ></div>
                <div 
                  v-if="hasStatus(date, '0')"
                  class="circle_yellow circle-link"
                  :class="{
                    click: isSelectedDate(date) && selectedColor === 'yellow',
                  }"
                  @click.stop="isMobile ? transitListApproved(date, 'blue') : inProgressVacation(date, 'yellow')"
                ></div>
              </div>
            </div>
            <div class="showList" style="height: 100%;" v-on:click="createVacation(date)"></div>
          </div>
        </div>
        <div v-else style="color: gray">
          <div style="height: 90px">
            <div
            :class="[{ 'mobile': isMobile }]"
            @click="handleClick(date)"
            style="height: 117px; width: 100%; margin-top: -5px"
          >
            <div style="height: 30px; width: 100%;" @click="transitListvacation()">
                <div
                  style="margin-top: -10px; margin-left: -8px"
                  :class="{
                    'current-day': isToday(day) && month === getCurrentMonth(),
                  }"
                  class="circle_blue1"
                >
                  <p>
                    <b>{{ day }}</b>
                  </p>
                </div>
            </div>
            <div class="showList"  style="height: 100%;" v-on:click="createVacation(date)"></div>
          </div>
            </div>
          </div>
      </template>
    </v-calendar>

  </v-sheet>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import {
  getUserRole,
  ListEvents,
  isApprover,
  TabNames,
  groupedDatesbyId,
  ScreenNames,
  resizeMixin
} from "../../utilities/CommonUtilities";

export default {
  mixins: [resizeMixin],
  data: () => ({
    calendarDate: null,
    calendarValue: new Date(),
    picker: null,
    selectedDate: null,
    selectedColor: null,
    listStatusDate: null,
  }),
  created() {
    this.picker = new Date().toISOString().substring(0, 7);
    this.initializeCalendarDate();
    this.notifyBus.$on(ListEvents.setStatusMonth, (list) => {
      if(list != undefined ){
        this.showStatusMonth(list)
      }
    });
  },
  inject: ["notifyBus"],
  mounted() {
    this.notifyBus.$on(ListEvents.calendarDate, (monthYear) => {
      this.calendarDate = monthYear;
      this.picker = monthYear;
    });
  },
  beforeDestroy() {
    this.notifyBus.$off(ListEvents.calendarDate);
  },
  computed: {
    ...mapState(["userInfo", "listUser"]),
    ...mapState({
      selectedTab: (state) => state.homeData.selectedTab,
      currentLanguage: state => state.homeData.currentLanguage,
      }),
    ...mapGetters({
      filterCalendar: "homeData/getFilterInfo",
    }),
    vuetifyLocale() {
      return this.currentLanguage;
    },
  },
  methods: {
    ...mapMutations({
      saveFilter: "homeData/saveFilter",
      setCurrentTab: "homeData/setCurrentTab",
      setSelectedTab: "homeData/setSelectedTab",
      setSelectedDate: "homeData/setSelectedDate",
      setCurrentScreen: "homeData/setCurrentScreen",
    }),
    createVacation(dayChoose) {
      if(this.isMobile)
        this.setCurrentScreen(ScreenNames.Calendar);
      this.setSelectedDate(dayChoose);
      this.$router.push({
         name: "applyVacation",
         params: { option: "create" },
      });
    },
    handleClick(dateChoose) {
      if (!this.isMobile) {
        this.createVacation(dateChoose);
      }
    },
    getCurrentMonth() {
      const date = new Date(this.calendarDate);
      return date.getMonth() + 1;
    },
    getCurrentYear() {
      const today = new Date();
      return today.getFullYear();
    },
    isToday(dayNumber) {
      const today = new Date();
      return (
        dayNumber === today.getDate() &&
        today.getMonth() + 1 === this.getCurrentMonth() &&
        today.getFullYear() === this.getCurrentYear()
      );
    },
    isSelectedDate(date) {
      if (
        this.filterCalendar == null ||
        this.filterCalendar.dateChoosed === undefined
      ) {
        return this.selectedDate == date;
      } else {
        const today = new Date().toISOString().substring(0, 10);
        let dateChoosed = this.filterCalendar.dateChoosed.substring(0, 10);
        this.selectedColor = this.filterCalendar.color;

        if(this.filterCalendar.datePicker && (dateChoosed !== today)){
        this.filterCalendar.dateChoosed = dateChoosed
        }else
        return this.filterCalendar.dateChoosed == date ;
      }
    },
    approvedVacation(dayChoose, color) {
        this.saveChoosedDay(dayChoose, color);
        this.setSelectedTab(TabNames.All);
        this.setCurrentTab(TabNames.All);
        this.notifyBus.$emit(ListEvents.vacationList);
    },
    inProgressVacation(dayChoose, color) {
      this.saveChoosedDay(dayChoose, color);
      this.setSelectedTab(TabNames.Requesting);
      this.notifyBus.$emit(ListEvents.vacationList);
    },
    saveChoosedDay(dayChoose, color) {
      if(dayChoose != undefined){
        this.selectedDate = dayChoose;
        this.selectedColor = color;
        var filterInfoTemp = {};
        filterInfoTemp.showDateChoose = true;
        filterInfoTemp.searchName = "";
        filterInfoTemp.dateChoosed = dayChoose;
        filterInfoTemp.fromDate = dayChoose;
        if(color != undefined) filterInfoTemp.color = color;
        filterInfoTemp.toDate = this.filterCalendar.lastDayOfMonth;
        filterInfoTemp.firstDayOfMonth = this.filterCalendar.firstDayOfMonth;
        filterInfoTemp.lastDayOfMonth = this.filterCalendar.lastDayOfMonth;
        this.saveFilter(filterInfoTemp);
      }
    },
    isShowIconInProgress() {
      if (!this.userInfo || !this.userInfo.serviceInformation) return;
      let userRole = getUserRole(this.userInfo.serviceInformation);
      if(!isApprover(userRole) && this.selectedTab === TabNames.Requesting){
        return userRole;
      } else
        return isApprover(userRole);
    },

    widthRate(date) {
      if (!this.userInfo || !this.userInfo.serviceInformation) return;
      let blueCircle = this.hasStatus(date, '1');
      let yellowCircle = this.hasStatus(date, '0') ;

      if ((blueCircle && !yellowCircle) || (!blueCircle && yellowCircle)) {
        return "75%";
      }

      return "55%";
    },
    updateLocale(locale) {
            this.vuetifyLocale = locale;
    },
    showStatusMonth(list){
      let startDate = new Date(this.filterCalendar.firstDayOfMonth);
      let endDate = new Date(this.filterCalendar.lastDayOfMonth);
      this.listStatusDate = groupedDatesbyId(list, startDate, endDate, this.listUser, 'calendar');
    },
    hasStatus(date, status) {
      if(this.listStatusDate != null){
        const dateString = this.formatDate(date);
        return this.listStatusDate[dateString] && this.listStatusDate[dateString].includes(status);
      }else{
        return;
      }
    },
    transitListvacation(){
        this.$router.push({
          name: "listVacation",
          params: { option: "list" },
      });  
    },
    transitListApproved(dayChoose, color) {
      if(this.isMobile)
        this.saveChoosedDay(dayChoose, color);
      this.setSelectedTab(TabNames.All);
      this.$router.push({
        name: "listVacation",
        params: { option: "list" },
      });
    },
    initializeCalendarDate() {
      if (this.filterCalendar.dateChoosed) {
      this.calendarDate = new Date(this.filterCalendar.dateChoosed);
      }
    },
    formatDate(date) {
      const d = new Date(date); 
      let month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

      if (month.length < 2) 
      month = '0' + month;
      if (day.length < 2) 
      day = '0' + day;

      return [year, month, day].join('-');
    },
  },
};
</script>

<style scoped>
.day-container {
  justify-content: flex-end;
  float: left;
  margin-left: 5px;
}

.cell-day {
  margin: 0px;
}

.circle-link:hover {
  background-color: #ddd;
}

@media (max-width: 767px) {
  .showList:active{
  background: #f0f8ff !important;
}
  .day-container {
    display: flex;
    justify-content: center;
    align-items: center;
    float: right;
    margin-right: 1px;
    margin-left: 0px !important;
  }
  /* use for mobile */
  .circle_blue, .circle_yellow {
    width: 10px !important;;
    height: 10px !important;
  }
  ::v-deep .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday,
  .circle_blue1 {
    font-size: 0.75em !important;
  }
  .circle_blue1{
    width: 35px !important;
    height: 27px !important;
    padding: 6px 5px 4px 10px !important;
  }
  ::v-deep .theme--light.v-calendar-weekly .v-calendar-weekly__day{
    height: 80px !important;
  }

  .circle-link::after {
    width: 10px !important;
    height: 10px !important;
  }

  .circle-link{
    margin: 5px 2px !important;
  }
  .widthRate{
    width: 30% !important;
  }
}

.circle-link {
  display: inline-block;
  margin: 10px 4px;
  border-radius: 50%;
  line-height: 100px;
  text-align: center;
  vertical-align: middle;
  position: relative;
}

.circle-link::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 21px;
  height: 21px;
  border: 2px solid transparent;
  padding: 5px;
  border-radius: 50%;
  transition: border-color 0.3s;
}

.circle_blue {
  background-color: #3fe090 !important;
  height: 20px;
  width: 20px;
}
.cell-day.selected{
  background-color: #f0f8ff;
}
.circle_blue.circle-link.selected,
.circle_yellow.circle-link.click {
  border-color: blue;
}

.circle_blue.selected::after,
.circle_yellow.selected::after {
  border-color: #1f97fe;
}

.circle_blue:active::after,
.circle_blue:focus::after,
.circle_yellow:active::after,
.circle_yellow:focus::after {
  border-color: #1f97fe;
}

div.circle_yellow {
  background-color: rgb(255, 179, 0) !important;
  height: 20px;
  width: 20px;
}

.circle_blue1 {
  margin-left: -6px;
  padding: 10px;
  margin-top: -9px;
  width: 50px;
  height: 44px;
}

.circle_blue1 p {
  border-radius: 15%;
  width: 100%;
  height: 100%;
}

.current-day p {
  color: #ffffff;
  background-color: #1f97fe;
}

.colum1 {
  flex: 2;
  margin: 0 25px 0 25px;
}

.colum2 {
  flex: 1;
  padding: 0px;
}

::v-deep
  .theme--light.v-calendar-weekly
  .v-calendar-weekly__head-weekday.v-outside {
  background-color: white;
  max-width: 159px;
}

::v-deep
  .theme--light.v-calendar-weekly
  .v-calendar-weekly__head-weekday.v-past {
  color: black;
}

::v-deep .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {
  border-right: none;
  font-size: medium;
  color: black !important;
}
::v-deep .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday:nth-child(1),
::v-deep .theme--light.v-calendar-weekly .v-calendar-weekly__day:nth-child(1) .cell-day{
  color: #FF3333 !important;
} 
::v-deep .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday:nth-child(7),
::v-deep .theme--light.v-calendar-weekly .v-calendar-weekly__day:nth-child(7) .cell-day{
  color: #1F97FE !important;
}
::v-deep .theme--light.v-calendar-weekly {
  border-top: none;
  border-left: none;
}

::v-deep .v-calendar-weekly__week {
  border-left: 1px solid #c7c7c7;
}

.v-list-item {
  min-height: 40px;
}

.v-sheet.theme--light {
  margin-right: 12px !important;
}

::v-deep .v-calendar-weekly__head {
  padding: 10px 0px;
  border-bottom: 1px solid #c7c7c7;
  max-width: 1114px;
}
::v-deep .theme--light.v-calendar-weekly .v-calendar-weekly__day {
  height: 117px;
  max-width: 159px;
}

@media (min-height: 601px) and (max-height: 800px) {
    ::v-deep .theme--light.v-calendar-weekly .v-calendar-weekly__day {
      height: 14vh;
    }
  } 

  @media (max-width: 767px) {
    #btnAddNew{
      background-color: #FEBD1F;
      width: 249px;
      color: white;
      font-size: 16px;
      height: 44px;
      font-weight: bolder;
      text-align: center;
      border-radius: 24px;
      margin: 40px 0;
      position: relative;
    }
    #applyImage{
      margin-right: 10px
      }
  }
</style>
